import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import bgcoupon from "../../../assets/admin/images/couponbg.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { Formik, Field, Form, ErrorMessage } from "formik";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import * as Yup from "yup";
import Loader from "../../../layouts/loader/Loader";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import {
  totalPageCalculator,
  communityLIMIT,
  Loyalty,
} from "../../../utlis/common.utlis";
import moment from "moment/moment";
import toast from "react-hot-toast";

const Page = () => {
  const [addCoupon, setAddCoupon] = useState({ status: false });
  const [deleteCou, setDeleteCou] = useState({ status: false, id: null });
  const [editCou, setEditCou] = useState({
    stat: false,
    id: null,
    title: null,
    description: null,
    loyalty_type: null,
    type: null,
    availableFor: null,
    code: null,
    value: null,
    valid_for_month: null,
    validFrom: null,
    validTo: null,
    status: null,
  });
  const [startDate, setStartDate] = useState(null);
  const [coupons, setCoupon] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loyaltyType, setLoyaltyType] = useState([]);
  const [couponType, setCouponType] = useState([]);

  const initialValues = {
    title: "",
    description: "",
    loyalty_type: "",
    type: "",
    availableFor: "",
    code: "",
    value: "",
    ValidForMonth: "",
    validFrom: "",
    validTo: "",
  };

  const initialEditValues = {
    title: editCou.title ?? "",
    description: editCou.description ?? "",
    loyalty_type: editCou.loyalty_type ?? "",
    type: editCou.type ?? "",
    availableFor: editCou.availableFor ?? "",
    code: editCou.code ?? "",
    value: editCou.value ?? "",
    ValidForMonth: editCou.valid_for_month ?? "",
    validFrom: editCou.validFrom ?? "",
    validTo: editCou.validTo ?? "",
    status: editCou.status ?? "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string()
      .required("Description is required!")
      .min(8, "Description must be 8 characters long."),
    loyalty_type: Yup.string().required("Loyalty Type is required!"),
    type: Yup.string().required("Type is required!"),
    availableFor: Yup.string().required("Available For is required!"),
    code: Yup.string().required("Code is required!"),
    value: Yup.number().required("Value is required!"),
    validFrom: Yup.date().required("Valid From is required!"),
    validTo: Yup.date().required("Valid To is required!"),
  });

  const validationEditSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    description: Yup.string()
      .required("Description is required!")
      .min(8, "Description must be 8 characters long."),
    loyalty_type: Yup.string().required("Loyalty Type is required!"),
    type: Yup.string().required("Type is required!"),
    availableFor: Yup.string().required("Available For is required!"),
    code: Yup.string().required("Code is required!"),
    value: Yup.number().required("Value is required!"),
    validFrom: Yup.date().required("Valid From is required!"),
    validTo: Yup.date().required("Valid To is required!"),
    status: Yup.string().required("Valid To is required!"),
  });

  const storeCoupon = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      title: formValue.title,
      description: formValue.description,
      loyalty_type: formValue.loyalty_type,
      type: formValue.type,
      availableFor: formValue.availableFor,
      code: formValue.code,
      value: formValue.value,
      ValidForMonth: formValue.ValidForMonth ?? null,
      validFrom: moment(formValue.validFrom).format("MM-DD-yyyy"),
      validTo: moment(formValue.validTo).format("MM-DD-yyyy"),
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.couponCreate,
      form
    );
    if (response.data.status) {
      setAddCoupon({ status: false });
      getCouponList(
        api.couponList + `?page=${pageNum}&limit=${communityLIMIT}`
      );
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const updateCoupon = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      title: formValue.title,
      description: formValue.description,
      loyalty_type: formValue.loyalty_type,
      type: formValue.type,
      availableFor: formValue.availableFor,
      code: formValue.code,
      value: formValue.value,
      ValidForMonth: formValue.ValidForMonth ?? null,
      validFrom: moment(formValue.validFrom).format("MM-DD-yyyy"),
      validTo: moment(formValue.validTo).format("MM-DD-yyyy"),
      status: formValue.status,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.couponUpdate + `${editCou.id}`,
      form
    );
    if (response.data.status) {
      setEditCou({
        stat: false,
        id: null,
        title: null,
        description: null,
        loyalty_type: null,
        type: null,
        availableFor: null,
        code: null,
        value: null,
        valid_for_month: null,
        validFrom: null,
        validTo: null,
        status: null,
      });
      getCouponList(
        api.couponList + `?page=${pageNum}&limit=${communityLIMIT}`
      );
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getCouponList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all users list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setCoupon(response.data.data.couponList);
      setTotal(response.data.data.total);
    } else setCoupon([]);
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    if (date !== null && date != undefined && date !== "")
      date = moment(date).format("DD-MM-yyyy");
    else date = "";
    getCouponList(
      api.couponList +
        `?page=${pageNum}&limit=${communityLIMIT}&search=${name}&start_date=${date}`
    );
  };

  const getLoyaltyTypeList = async (id, offerType = "") => {
    if (id == "" || id == null || id == undefined) return;
    const response = await ApiService.getAPIWithAccessToken(
      api.couponLoyaltyType + `${id}?offerType=${offerType}`
    );
    // console.log("sloyalty type list => ", response.data);
    if (response?.data?.status && response?.data?.statusCode === 200) {
      setLoyaltyType(response?.data?.data?.offerType);
      setCouponType(response?.data?.data?.couponType);
    } else {
      setLoyaltyType([]);
      setCouponType([]);
    }
  };

  const deleteCoupon = async (id) => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.couponDelete + `${id}`
    );
    setDeleteCou({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getCouponList(
        api.couponList + `?page=${pageNum}&limit=${communityLIMIT}`
      );
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCouponList(api.couponList + `?page=${pageNum}&limit=${communityLIMIT}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h3 className="heading-title">Manage Coupon </h3>
          <div className="cc-search-filter">
            <div className="row g-2">
              <div className="col-md-5">
                <div className="form-group search-form-group">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={(e) => handleFilter(e)}
                  />
                  <span className="search-icon">
                    <i className="cc-input-group-text  mdi mdi-magnify"></i>
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <DatePicker
                    toggleCalendarOnIconClick
                    showIcon
                    dateFormat={"MM-dd-yyyy"}
                    selected={startDate}
                    onChange={(date, e) => {
                      setStartDate(date);
                      handleFilter(e, date);
                    }}
                    className="DatePicker-control"
                    isClearable
                    name="date"
                    autoComplete="off"
                    placeholderText="Select Date"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <button
                    type="button"
                    className="btn-gr"
                    onClick={() => setAddCoupon({ status: true })}
                  >
                    Add New Coupon
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div chassName="care-content-coupon-list">
          <div className="row g-3">
            {coupons.length !== 0 ? (
              coupons.map((ele, indx) => {
                return (
                  <div key={indx} className="col-md-4">
                    <div className="coupon-card">
                      <div
                        className={
                          indx % 2
                            ? "coupon-card-coupon-name"
                            : "coupon-card-coupon-name-green"
                        }
                        style={{
                          backgroundImage: `url(${bgcoupon})`,
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <h2>{ele.code ?? "NA"}</h2>
                      </div>
                      <div className="coupon-card-content">
                        <h4>{ele.title ?? "NA"}</h4>
                        <h3 className="mb-1">{ele.description ?? "NA"}</h3>
                        <div
                          className="coupon-cat-status-box"
                          style={{ gap: "10px" }}
                        >
                          <div className="tags-item1 text-capitalize">
                            {ele.available_for ?? "NA"}
                          </div>
                          <div className="tags-item1 text-capitalize">
                            {Loyalty(ele.loyalty_type)}
                          </div>
                        </div>
                        <div className="coupon-cat-status-box">
                          <div className="date-text text-capitalize mb-0">
                            {ele.type ?? "NA"}
                          </div>
                        </div>
                        <div>
                          <div className="coupon-status status-active">
                            Status:{" "}
                            <span
                              className={
                                ele.status == 1 ? "text-green" : "text-danger"
                              }
                            >
                              {ele.coupon_status ?? "NA"}
                            </span>
                          </div>
                        </div>
                        <div className="coupon-date text-dark">
                          Offer Start From:{" "}
                          <span>{ele.valid_from ?? "NA"}</span>
                        </div>
                        <div className="coupon-date text-dark">
                          Offer Valid Till: <span>{ele.valid_to ?? "NA"}</span>
                        </div>
                      </div>
                      <div className="coupon-card-action">
                        <Link
                          className="coupon-offer-btn"
                          onClick={() => {
                            setEditCou({
                              stat: true,
                              id: ele.id,
                              title: ele.title,
                              description: ele.description,
                              loyalty_type: ele.loyalty_type,
                              type: ele.type,
                              availableFor: ele.available_for,
                              code: ele.code,
                              value: ele.value,
                              valid_for_month: ele.valid_for_month,
                              validFrom: ele.valid_from,
                              validTo: ele.valid_to,
                              status: ele.status,
                            });
                            getLoyaltyTypeList(ele.loyalty_type);
                          }}
                        >
                          Edit
                        </Link>
                        <Link
                          onClick={() =>
                            setDeleteCou({
                              status: true,
                              id: ele.id,
                            })
                          }
                          className="coupon-Delete-btn"
                        >
                          Delete
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center mt-3">
            {coupons.length !== 0 ? (
              <div className="care-table-pagination">
                <ul className="care-pagination">
                  {pageNum !== 1 && (
                    <li
                      className="disabled"
                      id="example_previous"
                      onClick={() => setPageNum(pageNum - 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="0"
                        tabIndex="0"
                        className="page-link"
                      >
                        Previous
                      </Link>
                    </li>
                  )}

                  {totalPageCalculator(total, communityLIMIT).length === 1
                    ? null
                    : totalPageCalculator(total, communityLIMIT).map(
                        (pageNo, indx) => {
                          return (
                            <li
                              className={pageNo === pageNum ? "active" : ""}
                              key={indx}
                              onClick={() => setPageNum(pageNo)}
                            >
                              <Link to="" className="page-link">
                                {pageNo}
                              </Link>
                            </li>
                          );
                        }
                      )}

                  {pageNum !== Math.ceil(total / communityLIMIT) && (
                    <li
                      className="next"
                      id="example_next"
                      onClick={() => setPageNum(pageNum + 1)}
                    >
                      <Link
                        to=""
                        aria-controls="example"
                        data-dt-idx="7"
                        tabIndex="0"
                        className="page-link"
                      >
                        Next
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        show={editCou.stat}
        onHide={() => {
          setEditCou({
            stat: false,
            id: null,
            title: null,
            description: null,
            loyalty_type: null,
            type: null,
            availableFor: null,
            code: null,
            value: null,
            valid_for_month: null,
            validFrom: null,
            validTo: null,
            status: null,
          });
          setLoyaltyType([]);
          setCouponType([]);
        }}
        className="cc-modal-form modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Coupon</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationEditSchema}
                onSubmit={updateCoupon}
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="row g-2">
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Coupon Title</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="title"
                            placeholder="Coupon Title"
                          />
                          <ErrorMessage
                            name="title"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Coupon Code</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="code"
                            placeholder="Coupon Code"
                          />
                          <ErrorMessage
                            name="code"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Coupon Description</h4>
                          <Field
                            as="textarea"
                            className="form-control todo-list-input"
                            name="description"
                            placeholder="Enter Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Coupon Loyalty Type</h4>
                          <Field name="loyalty_type">
                            {({ field }) => (
                              <select
                                {...field}
                                className="form-control"
                                disabled
                                onChange={(e) => {
                                  setFieldValue(field.name, e.target.value);
                                  getLoyaltyTypeList(e.target.value);
                                  setFieldValue("availableFor", "");
                                  setFieldValue("type", "");
                                }}
                              >
                                <option value="">Coupon Loyalty Type</option>
                                <option value="1">Offer & Discounts</option>
                                <option value="2">Subscription Plans</option>
                                <option value="3">Giveaways</option>
                                <option value="4">Contests</option>
                              </select>
                            )}
                          </Field>
                          <ErrorMessage
                            name="loyalty_type"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Coupon Offer Type</h4>
                          <Field
                            as="select"
                            disabled
                            type="text"
                            className="form-control todo-list-input"
                            name="availableFor"
                          >
                            <option value="">Select Offers Type</option>
                            {loyaltyType.map((ele, index) => (
                              <option key={index} value={ele}>
                                {ele}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="availableFor"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      {values.loyalty_type == "2" ||
                      editCou.loyalty_type == "2" ? (
                        <div className="col-md-4">
                          <div className="form-group">
                            <h4>Subscription Valid Month</h4>
                            <Field
                              as="select"
                              type="text"
                              className="form-control todo-list-input"
                              disabled
                              name="ValidForMonth"
                            >
                              <option value="1">1 Month</option>
                              <option value="3">3 Month</option>
                              <option value="6">6 Month</option>
                              <option value="12">12 Month</option>
                            </Field>
                            <ErrorMessage
                              name="ValidForMonth"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      ) : null}

                      <div
                        className={
                          values.loyalty_type == "2" ||
                          editCou.loyalty_type == "2"
                            ? "col-md-4"
                            : "col-md-6"
                        }
                      >
                        <div className="form-group">
                          <h4>Coupon Type</h4>
                          <Field
                            as="select"
                            type="text"
                            className="form-control todo-list-input"
                            name="type"
                            disabled
                          >
                            <option value="">Coupon Type</option>
                            {couponType.map((ele, index) => (
                              <option key={index} value={ele}>
                                {ele}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="type"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div
                        className={
                          values.loyalty_type == "2" ||
                          editCou.loyalty_type == "2"
                            ? "col-md-4"
                            : "col-md-6"
                        }
                      >
                        <div className="form-group">
                          <h4>Enter Value</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="value"
                            disabled
                            placeholder="Enter Value"
                          />
                          <ErrorMessage
                            name="value"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Valid From</h4>
                          <Field name="validFrom">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                toggleCalendarOnIconClick
                                showIcon
                                dateFormat={"MM-dd-yyyy"}
                                isClearable
                                autoComplete="off"
                                className="DatePicker-control"
                                minDate={new Date()}
                                selected={values.validFrom ?? ""}
                                onChange={(value) =>
                                  setFieldValue("validFrom", value)
                                }
                                placeholderText="Coupon Valid From"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="validFrom"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Valid Upto</h4>
                          <Field name="validTo">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                toggleCalendarOnIconClick
                                showIcon
                                dateFormat={"MM-dd-yyyy"}
                                isClearable
                                autoComplete="off"
                                className="DatePicker-control"
                                minDate={new Date()}
                                selected={values.validTo ?? ""}
                                onChange={(value) =>
                                  setFieldValue("validTo", value)
                                }
                                placeholderText="Coupon Valid To"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="validTo"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <Field
                          as="select"
                          type="text"
                          className="form-control todo-list-input"
                          name="status"
                        >
                          <option value="">Select Status</option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                          <option value="2">Cancel</option>
                        </Field>
                        <ErrorMessage
                          name="status"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>

                    <div className="form-group text-end mb-0">
                      <button
                        type="button"
                        onClick={() => {
                          setEditCou({
                            stat: false,
                            id: null,
                            title: null,
                            description: null,
                            type: null,
                            availableFor: null,
                            code: null,
                            value: null,
                            valid_for_month: null,
                            validFrom: null,
                            validTo: null,
                            status: null,
                          });
                          setLoyaltyType([]);
                          setCouponType([]);
                        }}
                        className="btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn-gr"
                        data-bs-dismiss="modal"
                      >
                        Update Coupon
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={addCoupon.status}
        onHide={() => {
          setAddCoupon({
            status: false,
          });
          setLoyaltyType([]);
          setCouponType([]);
        }}
        className="cc-modal-form modal-xl"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Add New Coupon</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={storeCoupon}
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="row g-2">
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Coupon Title</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="title"
                            placeholder="Coupon Title"
                          />
                          <ErrorMessage
                            name="title"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Coupon Code</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="code"
                            placeholder="Coupon Code"
                          />
                          <ErrorMessage
                            name="code"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Coupon Description</h4>
                          <Field
                            as="textarea"
                            className="form-control todo-list-input"
                            name="description"
                            placeholder="Enter Description"
                          />
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Coupon Loyalty Type</h4>
                          <Field name="loyalty_type">
                            {({ field }) => (
                              <select
                                {...field}
                                className="form-control"
                                onChange={(e) => {
                                  setFieldValue(field.name, e.target.value);
                                  getLoyaltyTypeList(e.target.value);
                                  setFieldValue("availableFor", "");
                                  setFieldValue("type", "");
                                }}
                              >
                                <option value="">Coupon Loyalty Type</option>
                                <option value="1">Offer & Discounts</option>
                                <option value="2">Subscription Plans</option>
                                <option value="3">Giveaways</option>
                                <option value="4">Contests</option>
                              </select>
                            )}
                          </Field>
                          <ErrorMessage
                            name="loyalty_type"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Coupon Offer Type</h4>
                          <Field name="availableFor">
                            {({ field }) => (
                              <select
                                {...field}
                                className="form-control"
                                onChange={(e) => {
                                  setFieldValue(field.name, e.target.value);
                                  getLoyaltyTypeList(values.loyalty_type, e.target.value);
                                  setFieldValue("type", "");
                                }}
                              >
                                <option value="">Select Offers Type</option>
                                {loyaltyType.map((ele, index) => (
                                  <option key={index} value={ele}>
                                    {ele}
                                  </option>
                                ))}
                              </select>
                            )}
                          </Field>
                          <ErrorMessage
                            name="availableFor"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      {values.loyalty_type == "2" ? (
                        <div className="col-md-4">
                          <div className="form-group">
                            <h4>Subscription Valid Month</h4>
                            <Field
                              as="select"
                              type="text"
                              className="form-control todo-list-input"
                              name="ValidForMonth"
                            >
                              <option value="1">1 Month</option>
                              <option value="3">3 Month</option>
                              <option value="6">6 Month</option>
                              <option value="12">12 Month</option>
                            </Field>
                            <ErrorMessage
                              name="ValidForMonth"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      ) : null}

                      <div
                        className={
                          values.loyalty_type == "2" ? "col-md-4" : "col-md-6"
                        }
                      >
                        <div className="form-group">
                          <h4>Coupon Type</h4>
                          <Field
                            as="select"
                            type="text"
                            className="form-control todo-list-input"
                            name="type"
                          >
                            <option value="">Coupon Type</option>
                            {couponType.map((ele, index) => (
                              <option key={index} value={ele}>
                                {ele}
                              </option>
                            ))}
                          </Field>
                          <ErrorMessage
                            name="type"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div
                        className={
                          values.loyalty_type == "2" ? "col-md-4" : "col-md-6"
                        }
                      >
                        <div className="form-group">
                          <h4>Enter Value</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="value"
                            placeholder="Enter Value"
                          />
                          <ErrorMessage
                            name="value"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Valid From</h4>
                          <Field name="validFrom">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                toggleCalendarOnIconClick
                                showIcon
                                dateFormat={"MM-dd-yyyy"}
                                isClearable
                                autoComplete="off"
                                className="DatePicker-control"
                                minDate={new Date()}
                                selected={values.validFrom ?? ""}
                                onChange={(value) =>
                                  setFieldValue("validFrom", value)
                                }
                                placeholderText="Coupon Valid From"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="validFrom"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Valid Upto</h4>
                          <Field name="validTo">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                toggleCalendarOnIconClick
                                showIcon
                                dateFormat={"MM-dd-yyyy"}
                                isClearable
                                autoComplete="off"
                                className="DatePicker-control"
                                minDate={new Date()}
                                selected={values.validTo ?? ""}
                                onChange={(value) =>
                                  setFieldValue("validTo", value)
                                }
                                placeholderText="Coupon Valid To"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="validTo"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group text-end mb-0">
                      <button
                        type="button"
                        onClick={() => {
                          setAddCoupon({
                            status: false,
                          });
                          setLoyaltyType([]);
                          setCouponType([]);
                        }}
                        className="btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn-gr"
                        data-bs-dismiss="modal"
                      >
                        Create New Coupon
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteCou.status}
        onHide={() => {
          setDeleteCou({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Coupon</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete your
                  coupon ?
                </p>
              </div>
              <div className="form-group text-center">
                <button
                  type="button"
                  onClick={() =>
                    setDeleteCou({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re me-2"
                  data-bs-dismiss="modal"
                  onClick={() => deleteCoupon(deleteCou.id)}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
